import { render, staticRenderFns } from "./StatsWidgets.vue?vue&type=template&id=72ec9524"
import script from "./StatsWidgets.vue?vue&type=script&lang=js"
export * from "./StatsWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports